export const productConstants = {

    GET_PRODUCT_REQUEST: 'GET_PRODUCT_REQUEST',
    GET_PRODUCT_SUCCESS: 'GET_PRODUCT_SUCCESS',
    GET_PRODUCT_FAILURE: 'GET_PRODUCT_FAILURE',

    GET_EXCEL_PRODUCTS_REQUEST: 'GET_EXCEL_PRODUCTS_REQUEST',
    GET_EXCEL_PRODUCTS_SUCCESS: 'GET_EXCEL_PRODUCTS_SUCCESS',
    GET_EXCEL_PRODUCTS_FAILURE: 'GET_EXCEL_PRODUCTS_FAILURE',

    UPLOAD_EXCEL_PRODUCTS_REQUEST: 'UPLOAD_EXCEL_PRODUCTS_REQUEST',
    UPLOAD_EXCEL_PRODUCTS_SUCCESS: 'UPLOAD_EXCEL_PRODUCTS_SUCCESS',
    UPLOAD_EXCEL_PRODUCTS_FAILURE: 'UPLOAD_EXCEL_PRODUCTS_FAILURE',

    ADD_PRODUCT_REQUEST: 'ADD_PRODUCT_REQUEST',
    ADD_PRODUCT_SUCCESS: 'ADD_PRODUCT_SUCCESS',
    ADD_PRODUCT_FAILURE: 'ADD_PRODUCT_FAILURE',



    EDIT_PRODUCT_REQUEST: 'EDIT_PRODUCT_REQUEST',
    EDIT_PRODUCT_SUCCESS: 'EDIT_PRODUCT_SUCCESS',
    EDIT_PRODUCT_FAILURE: 'EDIT_PRODUCT_FAILURE'

};
